import z from "zod";

export const getAttendanceParamSchema = z.object({
	userId: z.string(),
	attendanceId: z.uuid(),
});

export type GetAttendanceParamSchema = z.infer<typeof getAttendanceParamSchema>;
